module.exports = __webpack_public_path__ + "assets/images/island-map_a8c9dfd563bb2ded4b4b42393766aa5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/island-map.png
// module id = 184
// module chunks = 0